import axios from 'axios';
import { apiPublic } from "./apiPublic";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/auth";//

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


// Function to log in the user
export const login = async (userName: string, password: string) => {
  try {
    const response = await apiPublic.post('/login', { userName, password});
    if (response.data) {
      const {id, token, userName, email, role, mobileNumber } = response.data; 
  
      // Store the token and user details in localStorage
      localStorage.setItem('id', id);
      localStorage.setItem('token', token);
      localStorage.setItem('userName', userName);
      localStorage.setItem('email', email);
      localStorage.setItem('role', role);
      localStorage.setItem('mobileNumber', mobileNumber);
      
      console.log("Login successful:", response.data);
      return token;
    } else {
        console.error("Login failed: No data received");
        throw new Error('Login failed:');
    }
  } catch (error) {
    throw new Error('Login failed:' + error);
  }
};

// Function to register a new user
export const register = async (userName: string, parentId: String, password: string, firstName: string, middleName: string, lastName: string, role: string, mobileNumber: string, email: string, businessGroup: string[]) => {
  try {
    const response = await apiClient.post('/register', { userName, parentId, password, firstName, middleName, lastName, role, mobileNumber, email, businessGroup});
    const data = response.data;
   
   // localStorage.setItem('token', token); // Save the JWT token in localStorage
    return data;
  } catch (error) {
    throw new Error('Registration failed:' + error);
  }
};

// Function to log out the user
export const logout = async () => {
  const userName = localStorage.getItem("userName");
  
  localStorage.removeItem('id');
  localStorage.removeItem('token'); // Remove the token from localStorage
  localStorage.removeItem('userName');
  localStorage.removeItem('email');
  localStorage.removeItem('role');
  localStorage.removeItem('mobileNumber');
  localStorage.clear();

  await apiClient.post("/logout", {userName: userName});
};

// Function to get the currently authenticated token
export const getToken = (): string | null => {
  return localStorage.getItem('token'); // Retrieve the token from localStorage
};

// Function to check if the user is authenticated
export const isAuthenticated = (): boolean => {
  const token = getToken();
  return !!token; // Return true if the token exists, otherwise false
};

export async function getUserList() {
  const res = await apiClient.get("/user/list");
  
  return res.data;
}

export const changePassword = async(userName: string, oldPassword: string, newPassword: string) => {
  const res = await apiClient.post("/user/change-password", {userName, oldPassword, newPassword});
  
  return res.data;
}

export const getMyProfile = async(userName: string) => {
  const res = await apiClient.post("/user/my-profile", {userName});
  //alert(res.data);
  return res.data;
}

export const testApp = async () => {
  try {
    return (await apiClient.post('/testApp')).data;
  } catch (error) {
    throw new Error('Test App failed:' + error);
  }
};